export const ArrowRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
    <path
      d="M0.459961 4.80101V3.772H8.81096L6.65496 1.616L7.29196 0.979004L10.603 4.29L7.29196 7.60101L6.65496 6.96401L8.81796 4.80101H0.459961Z"
      fill="var(--text-black, #000)"
    />
  </svg>
);
